import { createApi } from '@reduxjs/toolkit/query/react'

import { customFetchBaseQuery } from '@/utils/api'
import { FetchAppScopesResponse, type CheckConsentResponse } from './interfaces'

export const accountsApi = createApi({
  reducerPath: 'accountsApi',
  baseQuery: customFetchBaseQuery({
    baseUrl: `${process.env.GATSBY_LC_ACCOUNTS_URL}/v2`,
  }),
  endpoints: ({ query }) => ({
    checkConsent: query<CheckConsentResponse, string>({
      query: (clientId, coverage = 'account') => ({
        path: `/clients/${encodeURIComponent(
          clientId
        )}/consent/status?coverage=${coverage}`,
      }),
    }),
    fetchAppScopes: query<FetchAppScopesResponse, string>({
      query: (clientId) => ({
        path: `/clients/${encodeURIComponent(clientId)}/public`,
      }),
      keepUnusedDataFor: 60 * 5, // 5 minutes
    }),
  }),
})

export const {
  useCheckConsentQuery,
  useFetchAppScopesQuery,
  reducer,
  reducerPath,
  middleware,
} = accountsApi
